import { render, staticRenderFns } from "./SafeDigInfoLayout.vue?vue&type=template&id=1494b2fc&scoped=true"
import script from "./SafeDigInfoLayout.vue?vue&type=script&lang=js"
export * from "./SafeDigInfoLayout.vue?vue&type=script&lang=js"
import style0 from "./SafeDigInfoLayout.vue?vue&type=style&index=0&id=1494b2fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1494b2fc",
  null
  
)

export default component.exports